export default __webpack_public_path__ + "static/media/item-4-safari-14.9871ef25.png";